import { Alert, Button, notification } from "antd";
import { useEffect, useRef, useState } from "react";
import { checkPlanPaymentApi } from "../../config/Api";
import { apiErrorMessage } from "../../services/ApiError";
import { rupees } from "./PlanOptions";

/**
 * Payments started but not confirmed (checkout closed early, or UPI finishing on the phone).
 * They are checked with Razorpay once when this opens, and again with "I've paid, check status".
 */
export const PendingPayments = ({ payments, onPaid }) => {
    const [checking, setChecking] = useState(false)
    const autoChecked = useRef(false)

    const check = (quiet) => {
        setChecking(true)
        checkPlanPaymentApi()
            .then((res) => {
                if (res.data.paid) {
                    notification.success({ message: res.data.message, duration: 8 })
                    onPaid && onPaid()
                } else if (!quiet) {
                    notification.info({ message: res.data.message, duration: 8 })
                }
            })
            .catch((err) => !quiet && notification.error({ message: apiErrorMessage(err) }))
            .finally(() => setChecking(false))
    }

    useEffect(() => {
        if (payments?.length && !autoChecked.current) {
            autoChecked.current = true
            check(true)
        }
    }, [payments])

    if (!payments?.length) return null

    return (
        <Alert
            className="mb-4"
            type="warning"
            showIcon
            message="A payment is waiting to be confirmed"
            description={payments.map((payment) => (
                <div key={payment.razorpay_order_id}>
                    {payment.plan} ({payment.billing_cycle}), {rupees(payment.amount)}, started {payment.created_at}
                </div>
            ))}
            action={<Button loading={checking} onClick={() => check(false)}>I've paid, check status</Button>}
        />
    )
}
